module.exports = __webpack_public_path__ + "static/media/tabs.4872fc39.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/legacy-app/tabs.md
// module id = 392
// module chunks = 0